import { createAction } from 'redux-actions';
import { actionKey } from '../constants';

export const reduxModuleLoaded = createAction(
  `${actionKey}.REDUX_READY`,
  () => ({})
);
